import { SEND_MESSAGE } from 'botframework-webchat-core/lib/actions/sendMessage';
const numericPIIMaskingMiddleware = () => (next) => (action) => {
    if (action.type === SEND_MESSAGE) {
        const obfuscated = action.payload.text.replace(/([\d\D]{2})\d+/g, '$1*');
        action.payload.text = obfuscated;
    }
    return next(action);
};
export { numericPIIMaskingMiddleware };
//# sourceMappingURL=numericPIIMaskingMiddleware.js.map